import { IS_OIDC_BUILD } from './config';
import type { AuthSession } from './types';
import { useOidcSession } from './useOidcSession';
import { useWorkOSSession } from './useWorkOSSession';

export { AuthProvider } from './AuthProvider';
export { AUTH, AUTH_AUDIENCE, AUTH_CONFIGURED, resolveAuthConfig } from './config';
export type { AuthProviderKind, ResolvedAuthConfig } from './config';
export type { AuthSession, AuthUser, GetTokenOptions, LoginOptions, LogoutOptions } from './types';

/**
 * The provider-neutral session hook. Resolved once at module load from
 * `VITE_AUTH_PROVIDER`, so every call site sees the same implementation for
 * the lifetime of the page.
 */
export const useAuthSession: () => AuthSession = IS_OIDC_BUILD ? useOidcSession : useWorkOSSession;
